module.exports = __webpack_public_path__ + "static/media/logo-decojovem.f22c2f16.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-decojovem.svg
// module id = 181
// module chunks = 0